export type PlanId = 'free' | 'plus' | 'premium';

export interface PlanLimits {
  maxGuests: number | null;
  maxTables: number | null;
  maxActiveInvitations: number;
  canExport: boolean;
  canCollaborate: boolean;
  canCustomizeBranding: boolean;
  canUseAITimeline: boolean;
}

export interface PlanConfig extends PlanLimits {
  id: PlanId;
  displayName: string;
  price: number | null;
}

export const PLAN_CONFIGS: Record<PlanId, PlanConfig> = {
  free: {
    id: 'free',
    displayName: '溫馨方案',
    price: null,
    maxGuests: 30,
    maxTables: 3,
    maxActiveInvitations: 1,
    canExport: false,
    canCollaborate: false,
    canCustomizeBranding: false,
    canUseAITimeline: false,
  },
  plus: {
    id: 'plus',
    displayName: '標準方案',
    price: 299,
    maxGuests: 500,
    maxTables: 50,
    maxActiveInvitations: 3,
    canExport: true,
    canCollaborate: true,
    canCustomizeBranding: false,
    canUseAITimeline: true,
  },
  premium: {
    id: 'premium',
    displayName: '進階方案',
    price: 499,
    maxGuests: null,
    maxTables: null,
    maxActiveInvitations: 10,
    canExport: true,
    canCollaborate: true,
    canCustomizeBranding: true,
    canUseAITimeline: true,
  },
};

export const DEFAULT_PLAN_ID: PlanId = 'free';
